import { Button } from 'twyne-new.ui';

import { useIntegrationStore } from '@Modules/settings/views/integration/store';

export default function Connect({ onChange }) {
  const { getGoogleAuthURL } = useIntegrationStore()

  const handleClick = async () => {
    const url = await getGoogleAuthURL()
    window.addEventListener("message", event => {
      onChange(event.data)
      popup.close()
    }, { once: true });

    const popup = open(url)
  }
  return <Button
    onClick={handleClick}
    color='accent'
    size='sm'
  >
    Connect
  </Button>
}
